import { copy } from "./shared";
import CheckoutForm from "./CheckoutForm";
import "../templates/Template10.css";
import "./CheckoutTemplate10.css";

/*
   Checkout Template 10 — a seamless continuation of sales Template 10
   ("Timeline Journey", warm/clean light). Reuses Template10.css directly (the
   same .clp10-root design system): the real .t10-nav (in its solid `scr`
   state), the light .t10-hero band with its radial .t10-hero-glow and the
   Fraunces .t10-title, the .t10-btn.t10-btn-p button and the dark .t10-foot.
   Only the form + order summary cards are checkout-specific
   (CheckoutTemplate10.css), styled to match the template's milestone cards.
*/
export default function CheckoutTemplate10({ data = {}, code }) {
  const c = copy(data);

  return (
    <div className="clp10-root scrolled">
      {/* NAV — same as the sales page (solid `scr` state) */}
      <nav className="t10-nav scr">
        <div className="t10-wrap t10-nav-in">
          <span className="t10-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok10-brandtext">{c.brand}</span>}
          </span>
          <span className="cok10-secure">🔒 Secure checkout</span>
        </div>
      </nav>

      {/* HERO — reuses the sales hero band + glow + Fraunces title */}
      <header className="t10-hero cok10-hero">
        <div className="t10-hero-glow" aria-hidden="true" />
        <div className="t10-wrap">
          <div className="cok10-hero-in">
            <span className="t10-eyebrow cok10-eyebrow">Checkout</span>
            <h1 className="t10-title">
              Complete your <span className="cok10-accent">enrollment</span>
            </h1>
            {c.sub ? <p className="t10-sub cok10-sub">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's milestone-card style */}
      <div className="t10-wrap">
        <CheckoutForm data={data} code={code} p="cok10" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="t10-foot">
        <div className="t10-wrap">
          <div className="cok10-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
